import {
  AnnounceIcon,
  DebitCardIcon,
  EditIcon,
  GiftIcon,
  HeartIcon,
  OngoingIcon,
  ProfileIcon,
  ShoppingBagIcon,
  SupportIcon,
  WalletIcon
} from 'assets/Icons';
import { MdCategory, MdOutlinePendingActions } from 'react-icons/md';

import { NavLinkProps as NavigationLink } from 'components/atoms/NavLinks/NavLinks';
import {
  BNPL,
  CATEGORIES,
  FAVOURITE,
  INBOX,
  ORDERS,
  PENDING_PAYMENTS,
  PROFILE,
  REFER,
  REVIEW,
  SUBSCRIPTIONS,
  SUPPORT,
  WALLET
} from '../routes';

export const NAVIGATION_LINKS: readonly NavigationLink[] = [
  {
    label: 'Profile',
    to: PROFILE,
    Icon: ProfileIcon
  },
  {
    label: 'My Orders',
    to: ORDERS,
    Icon: OngoingIcon
  },
  {
    label: 'BNPL',
    to: BNPL,
    Icon: DebitCardIcon
  },
  {
    label: 'Inbox',
    to: INBOX,
    Icon: AnnounceIcon
  },
  {
    label: 'My Wallet',
    to: WALLET,
    Icon: WalletIcon
  },

  {
    label: 'Reviews',
    to: REVIEW,
    Icon: EditIcon
  },
  {
    label: 'Favourites',
    to: FAVOURITE,
    Icon: HeartIcon
  },
  {
    label: 'Refer a Friend',
    to: REFER,
    Icon: GiftIcon
  },
  {
    label: 'Madina Subscriptions',
    to: SUBSCRIPTIONS,
    Icon: ShoppingBagIcon
  },
  {
    label: 'Support',
    to: SUPPORT,
    Icon: SupportIcon
  }
  // {
  //   label: 'Delete account',
  //   to: DELETE_ACCOUNT,
  //   Icon: AiOutlineUserDelete
  // }
] as const;

const excludeFromBusiness = ['Profile', 'My Orders', 'Refer a Friend', 'Madina Subscriptions'];

export const BUSINESS_NAVS: NavigationLink[] = [
  ...[
    {
      label: 'Profile',
      to: PROFILE,
      Icon: ProfileIcon
    },
    {
      label: 'My Orders',
      to: ORDERS,
      Icon: OngoingIcon
    },
    {
      label: 'Categories',
      to: CATEGORIES,
      Icon: MdCategory
    },
    {
      label: 'Pending Payments',
      to: PENDING_PAYMENTS,
      Icon: MdOutlinePendingActions
    }
  ],
  ...NAVIGATION_LINKS.filter(item => !excludeFromBusiness.includes(item.label))
];
